module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid erco-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-auto"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('a', {
    staticClass: "go-back",
    attrs: {
      "href": "/#/dashboard"
    }
  }, [_c('b-button', {
    staticClass: "_btn",
    attrs: {
      "size": "sm"
    }
  }, [_vm._v("\n\t\t\t\t\t\t×\n\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticClass: "id"
  }, [_vm._v(_vm._s(_vm.id))]), _vm._v(" "), _c('span', {
    staticClass: "bc"
  }, _vm._l((_vm.breadcrumb.concat(_vm.name)), function(entry) {
    return _c('span', {
      staticClass: "entry"
    }, [_vm._v(_vm._s(entry))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [(_vm.isVisitable) ? _c('b-button', {
    staticClass: "action-btn",
    attrs: {
      "size": "sm",
      "href": "#",
      "variant": "info"
    },
    on: {
      "click": _vm.handleClearCacheClick
    }
  }, [_vm._v("\n\t\t\t\tCache leeren\n\t\t\t\t"), (_vm.clearCacheButtonTooltip && _vm.clearCacheButtonTooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.clearCacheButtonTooltip.variant,
      "title": _vm.clearCacheButtonTooltip.title,
      "text": _vm.clearCacheButtonTooltip.text,
      "invertIcon": true,
      "offsetY": "1rem"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-button-group', {
    staticClass: "preview-block"
  }, [_c('b-button', {
    staticClass: "action-btn",
    attrs: {
      "size": "sm",
      "href": "#"
    },
    on: {
      "click": _vm.handleRenewPreviewClick
    }
  }, [(_vm.isVisitable) ? _c('span', [_vm._v("\n\t\t\t\t\t\tPreview erneuern\n\t\t\t\t\t\t"), (_vm.renewPreviewButtonTooltip && _vm.renewPreviewButtonTooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.renewPreviewButtonTooltip.variant,
      "title": _vm.renewPreviewButtonTooltip.title,
      "text": _vm.renewPreviewButtonTooltip.text,
      "invertIcon": true,
      "offsetY": "1rem"
    }
  }) : _vm._e()], 1) : _c('span', [_vm._v("\n\t\t\t\t\t\tPreview erstellen\n\t\t\t\t\t\t"), (_vm.createPreviewButtonTooltip && _vm.createPreviewButtonTooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.createPreviewButtonTooltip.variant,
      "title": _vm.createPreviewButtonTooltip.title,
      "text": _vm.createPreviewButtonTooltip.text,
      "invertIcon": true,
      "offsetY": "1rem"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.isVisitable) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "href": "#"
    },
    on: {
      "click": _vm.openSiteUrl
    }
  }, [_vm._v("\n\t\t\t\t\tAnsehen\n\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.isProductive && _vm.isVisitable) ? _c('b-button', {
    staticClass: "action-btn mr-4",
    attrs: {
      "size": "sm",
      "href": "#",
      "variant": "success"
    },
    on: {
      "click": _vm.handleRenewProductiveClickWithPreCheck
    }
  }, [_vm._v("\n\t\t\t\tOnline erneuern\n\t\t\t\t"), (_vm.renewOnlineButtonTooltip && _vm.renewOnlineButtonTooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.renewOnlineButtonTooltip.variant,
      "title": _vm.renewOnlineButtonTooltip.title,
      "text": _vm.renewOnlineButtonTooltip.text,
      "invertIcon": true,
      "offsetY": "1rem"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "actionConfirmation",
    staticClass: "action-confirmation-modal",
    attrs: {
      "id": "action-confirmation",
      "title": _vm.actionConfirmationModalState.title,
      "closeTitle": "Abbrechen"
    },
    on: {
      "ok": _vm.actionConfirmationModalState.okfunc
    }
  }, [_c('p', {
    staticClass: "_infotext"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.actionConfirmationModalState.text)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "selected-obj-list-container"
  }, [_c('b-list-group', {
    staticClass: "selected-obj-list"
  }, [_c('b-list-group-item', {
    staticClass: "_entry_"
  }, [_c('span', {
    staticClass: "_title font-weight-bold"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticClass: "_id float-left text-muted"
  }, [_vm._v(_vm._s(_vm.id))]), _vm._v(" "), _c('span', {
    staticClass: "_badge"
  }, [_c('erco-status-badge', {
    attrs: {
      "status": _vm.statusname
    }
  })], 1)])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10b5454b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoHeader.vue
// module id = 591
// module chunks = 0